module.exports = __webpack_public_path__ + "img/vol04_cup01_cover03.42f22fa4.jpg";